import * as React from 'react';
import * as classNames from "./SearchBar.css";

interface SearchBarProps {
  onSubmit: (npis: string[]) => void;
}

interface SearchBarState {
  searchText: string;
  error: string;
}

class SearchBar extends React.Component<SearchBarProps, SearchBarState> {
  constructor(props: SearchBarProps) {
    super(props);
    this.state = {
      searchText: '',
      error: ''
    };
  }

  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ searchText: e.target.value });
  };

  handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const npis = this.state.searchText.split(',').map(npi => npi.trim());
    if (npis.length === 0) {
      this.setState({error: 'Please enter at least one NPI'});
    } else {
      this.setState({error: ''});  // <-- Clear any previous error
      this.props.onSubmit(npis);
    }
  };

  render() {
    return (
      <div className={classNames.formWrapper}>
        <form onSubmit={this.handleSubmit}>
          <input
            type="text"
            placeholder="Enter NPIs (comma-separated)"
            value={this.state.searchText}
            onChange={this.handleChange}
            className={classNames.searchInput}
          />
          {this.state.error !== '' && <p className={classNames.errorText}>{this.state.error}</p>}
          <button type="submit" className={classNames.searchButton}>
            Load Patients
          </button>
        </form>
      </div>
    );
  }

}

export default SearchBar;




// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/pages/SearchBar.tsx